package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import one.healthium.uscreen.domain.models.ImageBlock
import one.healthium.uscreen.domain.models.LabelBlock
import one.healthium.uscreen.domain.models.RowBlock
import one.healthium.uscreen.domain.models.SpacerBlock
import one.healthium.uscreen.domain.models.UScreenBlock
import one.healthium.uscreen.ui.UScreenAnswer
import one.healthium.uscreen.ui.util.isVisible
import one.healthium.uscreen.ui.util.uscreenPadding

@Composable
fun UScreenRowBlock(
    modifier: Modifier = Modifier,
    block: RowBlock,
    isMale: Boolean?,
    answers: Map<String, UScreenAnswer> = emptyMap(),
) {
    val verticalAlignment = when (block.verticalAlignment) {
        "top" -> Alignment.Top
        "bottom" -> Alignment.Bottom
        else -> Alignment.CenterVertically
    }
    val horizontalArrangement = when (block.horizontalArrangement) {
        "center" -> Arrangement.Center
        "end" -> Arrangement.End
        "space_between" -> Arrangement.SpaceBetween
        "space_around" -> Arrangement.SpaceAround
        "space_evenly" -> Arrangement.SpaceEvenly
        else -> Arrangement.Start
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .uscreenPadding(block.padding)
            .testTag("uscreen_row"),
        verticalAlignment = verticalAlignment,
        horizontalArrangement = horizontalArrangement,
    ) {
        block.blocks.filter { it.isVisible(answers) }.forEach { childBlock ->
            RowChildRenderer(
                block = childBlock,
                isMale = isMale,
            )
        }
    }
}

@Composable
private fun RowScope.RowChildRenderer(
    block: UScreenBlock,
    isMale: Boolean?,
) {
    when (block) {
        is SpacerBlock -> UScreenSpacerBlockInRow(block = block)
        is LabelBlock -> UScreenLabelBlock(block = block, fillWidth = false, defaultHorizontalPadding = 0)
        is ImageBlock -> UScreenImageBlock(block = block, isMale = isMale)
        else -> {}
    }
}
